export const CONSTANTS = {
  errorToken: 142,
  notAuthorized: 143,
  errorValidationRole: 132,
  invalidReportToken: 147,
  reportTokenExpired: 148
}
